import moment from "moment";

import {
  REFRESHING_SESSION_TOKEN,
  refreshSessionToken,
} from "../reducers/currentUser";

// Action Parsing

const actionIsAxiosRequest = (action) => {
  return action.payload && action.payload.request;
};

const actionIsRefreshAction = (action) => {
  return action.types && action.types[0] === REFRESHING_SESSION_TOKEN;
};

// State Parsing

// We should trigger a refresh if we have a token to refresh with and our session token is about to expire
// or we haven't yet loaded the user
const shouldTriggerRefresh = (state) => {
  return (
    currentTokenExists(state) &&
    (currentTokenExpiring(state) || !currentUserLoaded(state))
  );
};

const currentTokenExists = (state) => {
  return state.currentUser.tokenExpiration && state.currentUser.refreshToken;
};

const currentUserLoaded = (state) => {
  return state.currentUser.user;
};

const urlHasBeenSelected = (state) => {
  return state.api?.url;
};

// How many minutes before expiration we should refresh
const EXPIRATION_TIMEOUT_MINUTES = 5;
const EXPIRATION_TIMEOUT_MS = EXPIRATION_TIMEOUT_MINUTES * 60 * 1000;

const currentTokenExpiring = (state) => {
  let tokenExpiration = moment(state.currentUser.tokenExpiration);
  let currentTime = moment(Date.now());

  let expiresIn = tokenExpiration - currentTime;

  return tokenExpiration && expiresIn < EXPIRATION_TIMEOUT_MS;
};

// Event Triggers

const triggerRefresh = (dispatch, action, state, next) => {
  if (state.currentUser.isRefreshingTokenPromise) {
    return state.currentUser.isRefreshingTokenPromise;
  }

  return refreshSessionToken()(dispatch);
};

// Exports

export const tokenRefresh = ({ dispatch, getState }) => {
  return (next) => (action) => {
    let state = getState();

    // We want to interject a token refresh action only if this action is an axios request that isn't
    // itself a token refresh action
    if (
      urlHasBeenSelected(state) &&
      actionIsAxiosRequest(action) &&
      !actionIsRefreshAction(action)
    ) {
      // Check if we actually need to refresh the token before running the refrehs
      if (shouldTriggerRefresh(state)) {
        return triggerRefresh(dispatch, action, state, next).then(() =>
          next(action)
        );
      }
    }

    return next(action);
  };
};
